<template>
  <form
      id="request-a-call-form"
      action=""
      method="POST"
      name="download_form"
      class="form-main form-request"
  >
    <br>

    <div
        class="input-field select"
        id="download_sub_product_wrapper"
        :class="{ countryShow: !countryShow, 'field-error': countryError }"
    >
      <select
          id="relatinshipId"
          class="select-text vue"
          v-model="relationship"
          ref="relationshipRef"
      >
        <option value="Prospective Customer" selected="selected">Prospective Customer</option>
        <option value="Customer">Customer</option>
        <option value="Partner">Partner</option>
        <option value="Contractor">Contractor</option>
        <option value="Employee">Employee</option>
        <option value="Former Employee">Former Employee</option>
        <option value="Other">Other</option>
      </select>
      <div class="select-label">Relationship with Starwind</div>
<!--      <span-->
<!--          v-if="countryError"-->
<!--          v-html="countryErrorMessage"-->
<!--          class="error"-->
<!--      ></span>-->
    </div>



    <div class="input-field" :class="{ 'field-error': firstnameError }">
      <input
          id="firstname"
          type="text"
          required="required"
          class="input"
          v-model.trim="firstname"
      />
      <span
          v-if="firstnameError"
          v-html="firstnameErrorMessage"
          class="error"
      ></span>

      <label for="firstname" class="label">First Name</label>
    </div>

    <div class="input-field" :class="{ 'field-error': lastnameError }">
      <input
          id="lastname"
          type="text"
          required="required"
          class="input"
          v-model.trim="lastname"
      />
      <span
          v-if="lastnameError"
          v-html="lastnameErrorMessage"
          class="error"
      ></span>
      <label for="lastname" class="label">Last Name</label>
    </div>

<!--    <div class="input-field" :class="{ 'field-error': titleError }">-->
<!--      <input-->
<!--          id="job"-->
<!--          type="text"-->
<!--          required="required"-->
<!--          class="input"-->
<!--          v-model.trim="title"-->
<!--      />-->
<!--      <span v-if="titleError" v-html="titleErrorMessage" class="error"></span>-->
<!--      <label for="job" class="label">Job Title</label>-->
<!--    </div>-->

    <div class="input-field" :class="{ 'field-error': emailError }">
      <input
          id="email"
          type="text"
          required="required"
          class="input"
          v-model.trim="email"
      />
      <span v-if="emailError" v-html="emailErrorMessage" class="error"></span>
      <label for="email" class="label">Email</label>
    </div>

    <div
        class="input-field select"
        id="download_sub_product_wrapper"
        :class="{ countryShow: !countryShow, 'field-error': countryError }"
    >
      <select
          id="download_country"
          class="select-text vue"
          v-model="country"
          ref="countryRef"
      ></select>
      <div class="select-label">Country</div>
      <span
          v-if="countryError"
          v-html="countryErrorMessage"
          class="error"
      ></span>
    </div>


<!--    usa states-->
    <div
        class="input-field select"
        :class="{ countryShow: !countryShow, 'field-error': countryError }"
        v-show="isUSA"
    >
      <select
          class="select-text vue"
          v-model="stateUSA"
          ref="statesUSARef"
      >
        <option value="">Choose a State</option><option  value="Alaska">Alaska</option><option  value="Alabama">Alabama</option><option  value="Arkansas">Arkansas</option><option  value="Arizona">Arizona</option><option  value="California">California</option><option  value="Colorado">Colorado</option><option  value="Connecticut">Connecticut</option><option  value="District of Columbia">District of Columbia</option><option  value="Delaware">Delaware</option><option  value="Florida">Florida</option><option  value="Georgia">Georgia</option><option  value="Hawaii">Hawaii</option><option  value="Iowa">Iowa</option><option  value="Idaho">Idaho</option><option  value="Illinois">Illinois</option><option  value="Indiana">Indiana</option><option  value="Kansas">Kansas</option><option  value="Kentucky">Kentucky</option><option  value="Louisiana">Louisiana</option><option  value="Massachusetts">Massachusetts</option><option  value="Maryland">Maryland</option><option  value="Maine">Maine</option><option  value="Michigan">Michigan</option><option  value="Minnesota">Minnesota</option><option  value="Missouri">Missouri</option><option  value="Mississippi">Mississippi</option><option  value="Montana">Montana</option><option  value="North Carolina">North Carolina</option><option  value="North Dakota">North Dakota</option><option  value="Nebraska">Nebraska</option><option  value="New Hampshire">New Hampshire</option><option  value="New Jersey">New Jersey</option><option  value="New Mexico">New Mexico</option><option  value="Nevada">Nevada</option><option  value="New York">New York</option><option  value="Ohio">Ohio</option><option  value="Oklahoma">Oklahoma</option><option  value="Oregon">Oregon</option><option  value="Pennsylvania">Pennsylvania</option><option  value="Rhode Island">Rhode Island</option><option  value="South Carolina">South Carolina</option><option  value="South Dakota">South Dakota</option><option  value="Tennessee">Tennessee</option><option  value="Texas">Texas</option><option  value="Utah">Utah</option><option  value="Virginia">Virginia</option><option  value="Vermont">Vermont</option><option  value="Washington">Washington</option><option  value="Wisconsin">Wisconsin</option><option  value="West Virginia">West Virginia</option><option  value="Wyoming">Wyoming</option>

      </select>
      <div class="select-label">State</div>
      <span
          v-if="stateError"
          v-html="stateErrorMessage"
          class="error"
      ></span>
    </div>


<!--    canada states-->
    <div
        class="input-field select"
        :class="{ countryShow: !countryShow, 'field-error': countryError }"
        v-show="isCanada"
    >
      <select
          class="select-text vue"
          v-model="stateCanada"
          ref="statesCanadaRef"
      >
        <option value="">Choose a State</option><option  value="Alberta">Alberta</option><option  value="British Columbia">British Columbia</option><option  value="Manitoba">Manitoba</option><option  value="New Brunswick">New Brunswick</option><option  value="Newfoundland and Labrador">Newfoundland and Labrador</option><option  value="Nova Scotia">Nova Scotia</option><option  value="Northwest Territories">Northwest Territories</option><option  value="Nunavut">Nunavut</option><option  value="Ontario">Ontario</option><option  value="Prince Edward Island">Prince Edward Island</option><option  value="Quebec">Quebec</option><option  value="Saskatchewan">Saskatchewan</option><option  value="Yukon Territories">Yukon Territories</option>

      </select>
      <div class="select-label">State</div>
      <span
          v-if="stateError"
          v-html="stateErrorMessage"
          class="error"
      ></span>
    </div>



    <div
        class="input-field select"

    >
<!--      что-то связанное с показыванием ошибок для purpose-->
<!--      :class="{ countryShow: !countryShow, 'field-error': countryError }" -->

      <select
          id="purposeId"
          class="select-text vue"
          v-model="purpose"
          ref="purposeRef"
      >
        <option value="Provide me a copy of my information">Provide me a copy of my information</option>
        <option value="Delete my personal information">Delete my personal information</option>
        <option value="Opt-out of marketing">Opt-out of marketing</option>
        <option value="Update my personal information">Update my personal information</option>
        <option value="Other privacy inquiry">Other privacy inquiry</option>
      </select>
      <div class="select-label">Purpose of the Request</div>
      <!--      <span-->
      <!--          v-if="countryError"-->
      <!--          v-html="countryErrorMessage"-->
      <!--          class="error"-->
      <!--      ></span>-->
    </div>

    <div class="input-field">
      <textarea
          id="quote_comments"
          class="textarea"
          v-model="comments"
      ></textarea>
      <label for="quote_comments" class="label">Additional comments (optional)</label>
    </div>

<!--    <div class="checkbox-wrap" v-if="checkEuroZone">-->
    <div class="checkbox-wrap">
      <div class="checkbox">
        <label
            id="quote_checkmark"
            for="quote_check_me"
            :class="{ error: !checkboxValid }"
        >
          <input
              type="checkbox"
              id="quote_check_me"
              required="required"
              v-model="checkboxInput"
          />
          <span class="checkbox-main">
            <span class="check"></span>
          </span>
          <span class="checkbox-text">

            <div class="text-title">By submitting this request, I confirm the following:</div>
            Accuracy: I affirm that the information I have provided is true and accurate. Privacy: I understand that the information I have provided will be used to verify my identity, process my request, and will be handled in accordance with the <a href="https://www.starwindsoftware.com/privacy-policy">StarWind Privacy Policy</a>.
            Contact: I acknowledge that StarWind may contact me to verify my identity and process this request, including providing guidance on any additional steps required with my web browser.

            <span class="error-checkbox" v-if="privacyPolicyError">
              Please confirm that you have read and accepted the Privacy Policy
              before proceeding
            </span>
          </span>
        </label>
      </div>
    </div>
<!--    <div class="checkbox-wrap" v-else>-->
<!--      <label id="quote_checkmark">-->
<!--          <span class="checkbox-text">-->
<!--              By submitting, you are agreeing to have your personal information managed-->
<!--              in accordance with the terms of StarWind Software Inc-->
<!--              <a href="https://www.starwindsoftware.com/privacy-policy" target="_blank">Privacy Policy</a>.-->
<!--          </span>-->
<!--      </label>-->
<!--    </div>-->

    <div class="input-field btn-wrap">
      <button type="submit" class="btn blue quote__form-submit" @click="SubmitForm">
        Submit
      </button>
    </div>
  </form>

  <div class="overlay_loader">
    <div class="loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
import Choices from "choices.js";
// import intlTelInput from "intl-tel-input";
import { useCookies } from "vue3-cookies";
import europe_zone_country from "./libs/eurozone";
import {
  filterErrors,
  sortErrors,
  ErrorMessages,
} from "./libs/errors_function";

export default {
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  data() {
    return {
      relationship: "",
      firstname: "",
      lastname: "",
      // title: "",
      email: "",
      // company: "",
      country: "",
      resolvedCountry: "",
      // phone: "",
      purpose: "",
      comments: "",
      isoCode: "",
      state: '',
      stateUSA: '',
      stateCanada: '',
      // phoneStandart: "",
      // phoneExt: "",
      // validPhone: false,

      formSuccess: false,

      checkboxInput: false,
      checkboxValid: true,
      privacyPolicyError: false,

      errors: {},

      // errors: {
      //   firstname: [],
      //   lastname: [],
      //   email: [],
      //   company: [],
      //   country: [],
      //   phone: [],
      // },

      statesUSARef: null,
      statesCanadaRef: null,
      purposeRef: null,
      countryRef: null,
      relationshipRef: null,
      intlTelInputRef: null,
      countriesList: [],

      countryShow: false, //стили не показывать страну, если список пуст
    };
  },
  created() {
    // console.clear();
    // const relationship  = document.getElementById('relatinshipId');
    // if(relationship != null) {
    //   console.log('created', relationship, relationship.value)
    // }


  },
  mounted() {
    // console.log(europe_zone_country);

    if(Choices != null) {

      this.countryRef = new Choices(this.$refs.countryRef, {
        searchEnabled: false,
        searchChoices: false,
        shouldSort: false,
        itemSelectText: "",
        allowHTML: true,
      });

      this.relationshipRef = new Choices(this.$refs.relationshipRef, {
        searchEnabled: false,
        searchChoices: false,
        shouldSort: false,
        itemSelectText: "",
        allowHTML: true,
      });

      this.purposeRef = new Choices(this.$refs.purposeRef, {
          searchEnabled: false,
          searchChoices: false,
          shouldSort: false,
          itemSelectText: "",
          allowHTML: true,
        });

      this.statesUSARef = new Choices(this.$refs.statesUSARef, {
          searchEnabled: false,
          searchChoices: false,
          shouldSort: false,
          itemSelectText: "",
          allowHTML: true,
        });

      this.statesCanadaRef = new Choices(this.$refs.statesCanadaRef, {
          searchEnabled: false,
          searchChoices: false,
          shouldSort: false,
          itemSelectText: "",
          allowHTML: true,
        });


      this.relationship = 'Prospective Customer';
      // this.relationship = 'Customer';
      this.relationshipRef.setChoiceByValue(this.relationship)

      this.purpose = 'Provide me a copy of my information';
      this.purposeRef.setChoiceByValue(this.purpose);

    }


    this.initFunction();

    // this.cookies.set('lightenc', '04710de004cac371127eaac330834486da3ff4588542b9429facca980b398d3a6e3ef9dd15a189e0f1896f40cee58434926920097fb1b035caeb1cf35fdbfb64a0a81627ea21a164c8923ed32c87e38ff7adc680248dbd63fbe1ac8045962f7c47cc29e3b5acd0dc880906d53e7ee018997388fba8dc88a3c72d9ccb7ac00fbf3177387a1427930b72e8845d43bab3f4cdfd31652bfc4b0d132de7c5227f0355ec1e60768e69a2a937f62483e63b1f095835e0d3def3bb9d51ec2244077423bdb47021d1cd8c53d5e30239c7d0ba9137caa6ed9b2881b19e1e01c56a407a076ff0f9d01e99525827d9bf5bc2ae825fb4a387566a3ec1410dbdd244b156234998c1250976fa96789096ef994ca11d55602b839e45210754e2d48b975b8c9c505dc568058763f14384f7dd5dd3e74a29542bfe79156e888fcf561659be82d9744ad0396a5c1f5db4e8');
    // const cookie = this.cookies.get("lightenc");
    // console.log('cookie lightenc', cookie);
  },
  methods: {
    setPreloader(toggle = false) {
      const el = document.querySelector("body");

      if (el == null) {
        return;
      }

      if (toggle) {
        el.classList.add("preloader");
        return;
      }

      el.classList.remove("preloader");
    },

    checkError(data) {
      // console.log('checkError', data);

      const errors = {
        length: 0,
      };

      for (const key of data) {
        if (errors[key["field"]] != null) {
          errors[key["field"]].push(key["rule"]);
        } else {
          errors[key["field"]] = [key["rule"]];
        }
        errors.length += 1;
      }

      const sortErr = sortErrors(errors);
      this.errors = filterErrors(sortErr);

      // console.log('errors', errors);
      // console.log('sortErr', sortErr);
      // console.log('filterErr', this.errors);
    },

    setModel() {
      // console.clear();
      //check phone
      // this.validPhone = false;
      // if (this.intlTelInputRef.isValidNumber()) {
      //   // console.log('valid number');
      //   this.validPhone = true;
      //   this.phoneExt = this.intlTelInputRef.getExtension();
      //   if (this.phoneExt == null) {
      //     this.phoneExt = "";
      //   }
      //   this.phoneStandart = this.intlTelInputRef.getNumber(0);
      // }

      switch(this.country) {
        case 'United States':
          this.state = this.stateUSA;
          break;
        case 'Canada':
          this.state = this.stateCanada;
          break;
        default:
          this.state = '';
          break;
      }

      const model = {
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        country: this.country,
        comments: this.comments,
        relationship: this.relationship,
        purpose: this.purpose,
        state: this.state,
        formType: 'data-subject-request',
      };

      // console.log('model', model);
      // console.dir(model);

      return model;
    },
    async initFunction() {
      await this.fillCountries(); //заполняем страны
      // await this.setPhonePlugin(); //подключаем плагин телефона
      await this.getCookieDetail(); //получаем куки
    },
    async SubmitForm(e) {

      e.preventDefault();


      // console.log("SubmitForm");
      //проверяем чекбоксы
      // if (this.checkEuroZone) {

        this.privacyPolicyError = false;

        if (!this.checkboxInput) {
          this.checkboxValid = false;
          this.privacyPolicyError = true;
          return;
        } else {
          this.checkboxValid = true;
        }
      // }

      const model = this.setModel();

      const formData = new URLSearchParams();
      // console.log( model);
      for (const item of Object.keys(model)) {
        // console.log(item, model[item]);
        formData.append(item, model[item]);
      }

      // console.log(formData);

      this.errors = {};

      // console.clear();
      // console.log(model)
      // console.log(this.relationshipRef.value)
      // return;

      //send form data
      // eslint-disable-next-line no-unreachable
      this.setPreloader(true);
      const response = await fetch(
          // "https://www.starwindsoftware.com/request-a-call-2023.js",
          "https://www.starwindsoftware.com/point-form-validation.js",
          {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: formData,
          }
      );
      this.setPreloader(false);

      const responseData = await response.json();

      // console.log(responseData, responseData.success, responseData.data);
      if (responseData.success != null && !responseData.success) {
        this.checkError(responseData.data);
        // await this.checkError(responseData.data);
      }

      if (responseData.success != null && responseData.success) {
        const el = document.querySelector("body");
        if (el != null) {
          el.classList.add("form-done");

        const thankEl = document.querySelector("#quote-thank-you-1");
        if(thankEl != null) {
          thankEl.style.display = 'block';
        }



        }

        //типа скролл лол
        const el2 = document.getElementById("download");

        if (el2) {
          el2.scrollIntoView();
        }
      }
    },
    async getCookieDetail() {
      // console.log('getCookieDetail');

      const cookieValue = this.cookies.get("lightenc");

      const formData = new URLSearchParams({ cookieName: cookieValue });

      const response = await fetch(
          "https://www.starwindsoftware.com/cookie-detail.js",
          {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: formData,
          }
      );

      const responseData = await response.json();

      if (responseData.status == null) {
        return;
      }

      if (responseData.type == null || responseData.type !== "cookie-detail") {
        return;
      }

      if (responseData.result == null) {
        return;
      }

      if (responseData.result.firstname != null) {
        this.firstname = responseData.result.firstname;
      }

      if (responseData.result.lastname != null) {
        this.lastname = responseData.result.lastname;
      }

      if (responseData.result.email != null) {
        this.email = responseData.result.email;
      }

      // if (responseData.result.title != null) {
      //   this.title = responseData.result.title;
      // }

      // if (responseData.result.company != null) {
      //   this.company = responseData.result.company;
      // }

      if (responseData.result.country != null) {
        const country = responseData.result.country;
        // const country = 'Poland';
        this.countryRef.setChoiceByValue(country);
        this.country = country;
      }

      // if (responseData.result.phone != null) {
      //   this.intlTelInputRef.setNumber(responseData.result.phone);
      //   let code = await this.intlTelInputRef.getSelectedCountryData();
      //   code = code.dialCode;
      //
      //   let phone = responseData.result.phone;
      //   phone = phone.replace("+", ""); //убираем +
      //   if (code !== "") {
      //     phone = phone.replace(code, ""); //clean code in number
      //   }
      //
      //   this.intlTelInputRef.setNumber(phone); //set phone
      //   this.phone = phone; //set model phone
      // }
    },
    // setPhonePlugin() {
    //   // if (intlTelInput != null) {
    //   //   this.intlTelInputRef = intlTelInput(this.$refs.phoneRef, {
    //   //     utilsScript:
    //   //         "https://www.starwindsoftware.com/assets/libraries/intl-tel-input-17.0.19/build/js/utils.js",
    //   //     // utilsScript: loadUtils("build/js/utils.js"),
    //   //     preferredCountries: [],
    //   //     autoPlaceholder: "aggressive",
    //   //     separateDialCode: true,
    //   //   });
    //   // }
    // },
    async fillCountries() {
      // console.log('fillCountries');

      const data = await this.getCountryList();

      const arr = [];

      for (const item in data.countries) {
        arr.push({ value: item, label: item });
      }

      this.countryRef.setValue(arr);

      if (data.detectedCountry !== "") {
        this.countryRef.setChoiceByValue(data.detectedCountry);
        this.country = data.detectedCountry;
      }

      this.countryShow = true; //включаем показ стран
    },
    async getCountryList() {
      const response = await fetch(
          "https://www.starwindsoftware.com/v21-ajax-countries.js",
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
      );
      return response.json();
    },
    async getISO(newCountry) {
      const formData = new URLSearchParams({ country: newCountry });

      const response = await fetch(
          "https://www.starwindsoftware.com/geoip-detail.js",
          {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: formData,
          }
      );

      const data = await response.json();

      if (data.status == null) {
        return;
      }

      if (data.type == null || data.type !== "country-detail") {
        return;
      }

      if (data.isoCode == null) {
        return;
      }

      // const phoneCountry = this.getCookieValue("phoneCountry");
      //
      // if (phoneCountry === "") {
      //   this.isoCode = data.isoCode;
      // } else {
      //   this.isoCode = phoneCountry;
      // }

      // this.intlTelInputRef.setCountry(this.isoCode);
    },
    getCookieValue(name) {
      return (
          document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() ||
          ""
      );
    },
    generateErrorMessage(field) {
      if (this.errors[field] != null) {
        const rule = this.errors[field][0];
        return ErrorMessages[field][rule];
      }
      return "";
    },
    checkFieldError(field) {
      if (this.errors[field] != null) {
        return true;
      }
      return false;
    },
  },
  watch: {
    country(newCountry) {
      // console.log('watch country', newCountry)
      this.getISO(newCountry);
    },
  },
  computed: {
    checkEuroZone() {
      return europe_zone_country.includes(this.country);
    },
    firstnameError() {
      const key = "firstname";
      return this.checkFieldError(key);
    },
    firstnameErrorMessage() {
      const key = "firstname";
      return this.generateErrorMessage(key);
    },
    lastnameError() {
      const key = "lastname";
      return this.checkFieldError(key);
    },
    lastnameErrorMessage() {
      const key = "lastname";
      return this.generateErrorMessage(key);
    },
    emailError() {
      const key = "email";
      return this.checkFieldError(key);
    },
    emailErrorMessage() {
      const key = "email";
      return this.generateErrorMessage(key);
    },
    countryError() {
      const key = "country";
      return this.checkFieldError(key);
    },
    countryErrorMessage() {
      const key = "country";
      return this.generateErrorMessage(key);
    },
    stateError() {
      const key = "state";
      return this.checkFieldError(key);
    },
    stateErrorMessage() {
      const key = "state";
      return this.generateErrorMessage(key);
    },
    isCanada() {
      return this.country === 'Canada'
    },
    isUSA() {
      return this.country === 'United States'
    },
  },
};
</script>

<style scoped>
.countryShow {
  display: none;
}
</style>

<!--https://www.npmjs.com/package/vue3-cookies-->
<!--https://learn.javascript.ru/async-await-->
